import {
  PROTECTED,
  FX_LAUNCH_ENABLED,
  CONVERT_SECTION,
} from '@services/permissions'

import type { Section } from '../types'

export const wireReceiveDetail: Section = {
  label: 'layout:page.payments.transaction.wire',
  route: '/payments/wire-receive/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const wireWithdrawalDetail: Section = {
  label: 'layout:page.payments.transaction.wire',
  route: '/payments/wire-withdrawal/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const withdrawalDetail: Section = {
  label: 'layout:page.payments.transaction.payout',
  route: '/payments/withdrawal/[id]',
  permissions: FX_LAUNCH_ENABLED,
  segment: {
    page: 'home',
  },
}

export const depositDetail: Section = {
  label: 'layout:page.payments.transaction.deposit',
  route: '/payments/deposit/[id]',
  permissions: FX_LAUNCH_ENABLED,
  segment: {
    page: 'home',
  },
}

export const tradeMintDetail: Section = {
  label: 'layout:page.payments.transaction.tradeMint',
  route: '/payments/trade-mint/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const tradeWithdrawalDetail: Section = {
  label: 'layout:page.payments.transaction.tradeWithdrawal',
  route: '/payments/trade-withdrawal/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const convertMintDetail: Section = {
  label: 'layout:page.payments.transaction.convertMint',
  route: '/payments/convert-mint/[id]',
  permissions: CONVERT_SECTION,
  segment: {
    page: 'home',
  },
}

export const convertWithdrawalDetail: Section = {
  label: 'layout:page.payments.transaction.convertWithdrawal',
  route: '/payments/convert-withdrawal/[id]',
  permissions: CONVERT_SECTION,
  segment: {
    page: 'home',
  },
}

export const customerFxBatchSettlementDetail: Section = {
  label: 'layout:page.payments.transaction.customerFxBatchSettlement',
  route: '/payments/customer-fx-batch-settlement/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const paymentDetail: Section = {
  label: 'layout:page.payments.transaction.details',
  route: '/payments/details/[id]',
  permissions: PROTECTED,
  segment: {
    page: 'home',
  },
}

export const paymentsSections: Section = {
  label: 'layout:page.payments.title',
  route: '/payments/',
  permissions: PROTECTED,
  pages: [
    wireWithdrawalDetail,
    wireReceiveDetail,
    withdrawalDetail,
    depositDetail,
    tradeMintDetail,
    tradeWithdrawalDetail,
    convertMintDetail,
    convertWithdrawalDetail,
    paymentDetail,
    customerFxBatchSettlementDetail,
  ],
}
